<script>
  import servico from '../servico';
  
  export default {
    data() {
      return {
        carregando: true,
        id: null,
        status: null, 
        naoEncontrada: false,
        nomeSolicitacao: "",
        configuracao: this.$storage.configuracao(),
      };
    },
    methods: {
      liberar(solicitacao) {
        return servico
          .liberar(solicitacao, this.$route.params.id, this.$route.params.coordenador);
      },
      cancelar(solicitacao) {
        return servico
          .cancelar(solicitacao, this.$route.params.id, this.$route.params.coordenador);
      }
    },
    mounted() {
      let solicitacao = '';
      
      if (this.$route.name.endsWith('compra')) {
        this.nomeSolicitacao = "solicitacao de compra";
        solicitacao = 'compra';
      } else if (this.$route.name.endsWith('pagamento')) {
        this.nomeSolicitacao = "solicitacao de pagamento";
        solicitacao = 'pagamento';
      } else if (this.$route.name.endsWith('reembolso')) {
        this.nomeSolicitacao = `Solicitação de Diária ${ this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }`;
        solicitacao = 'reembolso';
      } else if (this.$route.name.endsWith('faturamento')) {
        this.nomeSolicitacao = "solicitacao de faturamento";
        solicitacao = 'faturamento';
      } else if (this.$route.name.endsWith('faturamento-multiservico')) {
        this.nomeSolicitacao = "solicitacao de faturamento multiserviço";
        solicitacao = 'faturamento-multiservico';
      } else if (this.$route.name.endsWith('bolsa')) {
        this.nomeSolicitacao = "solicitacao de bolsa";
        solicitacao = 'bolsa';
      }
      
      let funcao = null;
      
      if (this.$route.name.startsWith('liberar')) {
        funcao = this.liberar(solicitacao);
      } else {
        funcao = this.cancelar(solicitacao);
      }
      
      funcao
        .then(retorno => {
          this.carregando = false;
          this.id = retorno.id;
          this.status = retorno.status;
        })
        .catch(erro => {
          this.carregando = false;
          
          if (erro.status === 404) {
            this.naoEncontrada = true;
          } else {
            this.$mensagemErro(erro, 'Erro ao tentar liberar/cancelar a solicitação.');
          }
        });
    },
    computed: {
      liberacao() {
        return this.$route.name.startsWith('liberar');
      }
    }
  }
</script>

<template>
  <div>
    <div class="row hidden-print">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>{{ liberacao ? 'Liberação' : 'Cancelamento'}} de {{ nomeSolicitacao }}</h5>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                
                <div v-show="carregando">
                  <i class='fa fa-spinner fa-pulse'></i> {{liberacao ? 'Liberando' : 'Cancelando'}}...
                </div>

                <div class="alert alert-success" role="alert" v-show="!carregando && status === 0">
                  <i class='fa fa-check'></i> <span class="capitalize">{{ nomeSolicitacao }} nº {{ id }} liberada com sucesso.</span>
                </div>

                <div class="alert alert-info" role="alert" v-show="!carregando && status === 6">
                  <i class='fa fa-exclamation-circle'></i> <span class="capitalize">A {{ nomeSolicitacao }} nº {{ id }} já foi liberada.</span>
                </div>

                <div class="alert alert-success" role="alert" v-show="!carregando && (status === 3 || status === 4)">
                  <i class='fa fa-check'></i> <span class="capitalize">{{ nomeSolicitacao }} nº {{ id }} cancelada com sucesso.</span>
                </div>

                <div class="alert alert-info" role="alert" v-show="!carregando && status === 5">
                  <i class='fa fa-exclamation-circle'></i> <span class="capitalize">A {{ nomeSolicitacao }} nº {{ id }} já foi cancelada.</span>
                </div>

                <div class="alert alert-danger" role="alert" v-show="!carregando && naoEncontrada">
                  <i class='fa fa-exclamation-triangle'></i> <span class="capitalize">{{ nomeSolicitacao }} nº {{ id }} não encontrada.</span>
                </div>
                
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-cancelar-solicitacao/componentes/LiberarCancelarSolicitacao.vue